import { render, staticRenderFns } from "./DatasourceDataTable.vue?vue&type=template&id=1547a1fe&scoped=true&"
import script from "./DatasourceDataTable.vue?vue&type=script&lang=js&"
export * from "./DatasourceDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DatasourceDataTable.vue?vue&type=style&index=0&id=1547a1fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547a1fe",
  null
  
)

export default component.exports